"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var localisationSlice_1 = require("@store/slices/localisationSlice");
var styles = __importStar(require("./SetLocalisation.module.scss"));
var SetLocalisation = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var currentLanguage = (0, react_redux_1.useSelector)(function (state) { return state.localisationSlice.currentLanguage; });
    var handleLanguageChange = function (language) {
        if (language !== currentLanguage) {
            dispatch((0, localisationSlice_1.setLanguage)(language));
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: styles.container, children: [(0, jsx_runtime_1.jsx)("button", { className: "".concat(styles.button, " ").concat(currentLanguage === 'en' ? styles.active : ''), onClick: function () { return handleLanguageChange('en'); }, children: "English" }), (0, jsx_runtime_1.jsx)("button", { className: "".concat(styles.button, " ").concat(currentLanguage === 'ru' ? styles.active : ''), onClick: function () { return handleLanguageChange('ru'); }, children: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439" })] }));
};
exports.default = SetLocalisation;
